import React from "react";
import { useForm } from "react-hook-form";
import style from "./Form.module.css";
import {
  validation,
  validationEmail,
  validationName,
  validationPhone,
} from "../../common";
import {
  CONTACT_TEMPLATE_ID,
  CONTACT_SERVICE_ID,
} from "../../common";
import Modal from "react-modal";
import { Done, Error } from "../../customIcons";
import { Loader } from "../Loader";
import { useEmailForm } from "../../hooks/useEmailForm";
Modal.setAppElement("#root");

export const Form = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "onChange",
  });
  const { formRef, status, submit, resetStatus } = useEmailForm({
    serviceId: CONTACT_SERVICE_ID,
    templateId: CONTACT_TEMPLATE_ID,
    reset,
  });
  const isLoading = status === "loading";
  const modalIsOpen = status === "success" || status === "error";

  return (
    <>
      <form
        ref={formRef}
        onSubmit={handleSubmit(submit)}
        className={style.form}
        noValidate
      >
        <label className={style.formLabel} htmlFor="firstName">
          <span>First Name*</span>
          <input
            id="firstName"
            autoComplete="given-name"
            className={style.formInput}
            {...register("firstName", validationName)}
          />
          {errors.firstName && (
            <p className={style.formError}>{errors.firstName?.message}</p>
          )}
        </label>
        <label className={style.formLabel} htmlFor="lastName">
          <span>Last Name*</span>
          <input
            id="lastName"
            autoComplete="family-name"
            className={style.formInput}
            {...register("lastName", validationName)}
          />
          {errors.lastName && (
            <p className={style.formError}>{errors.lastName?.message}</p>
          )}
        </label>
        <label className={style.formLabel} htmlFor="email">
          <span>Email*</span>
          <input
            id="email"
            type="email"
            autoComplete="email"
            className={style.formInput}
            {...register("email", validationEmail)}
          />
          {errors.email && (
            <p className={style.formError}>{errors.email?.message}</p>
          )}
        </label>
        <label className={style.formLabel} htmlFor="phone">
          <span>Phone number*</span>
          <input
            id="phone"
            type="tel"
            autoComplete="tel"
            className={style.formInput}
            {...register("phone", validationPhone)}
          />
          {errors.phone && (
            <p className={style.formError}>{errors.phone?.message}</p>
          )}
        </label>
        <div className={style.checkboxGroup}>
          <p className={style.checkboxGroupTitle}>
            Preferred Method of Contact:
          </p>
          <label className={style.formCheckboxLabel}>
            <input
              className={style.formInputCheckbox}
              type="checkbox"
              value="call"
              {...register("contactCall")}
            />
            <span className={style.checkboxText}>Call</span>
          </label>
          <label className={style.formCheckboxLabel}>
            <input
              className={style.formInputCheckbox}
              type="checkbox"
              value="email"
              {...register("contactEmail")}
            />
            <span className={style.checkboxText}>Email</span>
          </label>
          <label className={style.formCheckboxLabel}>
            <input
              className={style.formInputCheckbox}
              type="checkbox"
              value="text"
              {...register("contactText")}
            />
            <span className={style.checkboxText}>Text</span>
          </label>
        </div>
        <label className={style.formLabel} htmlFor="message">
          <span>Message*</span>
          <textarea
            id="message"
            className={style.formMessage}
            {...register("message", validation)}
          />
          {errors.message && (
            <p className={style.formError}>{errors.message?.message}</p>
          )}
        </label>
        <label className={style.formLabel} htmlFor="address">
          <span>Street address</span>
          <input
            id="address"
            autoComplete="street-address"
            className={style.formInput}
            {...register("address")}
          />
          {errors.address && (
            <p className={style.formError}>{errors.address?.message}</p>
          )}
        </label>
        <label className={style.formLabel} htmlFor="city">
          <span>City</span>
          <input
            id="city"
            autoComplete="address-level2"
            className={style.formInput}
            {...register("city")}
          />
          {errors.city && (
            <p className={style.formError}>{errors.city?.message}</p>
          )}
        </label>
        <label className={style.formLabel} htmlFor="state">
          <span>State</span>
          <input
            id="state"
            autoComplete="address-level1"
            className={style.formInput}
            {...register("state")}
          />
          {errors.state && (
            <p className={style.formError}>{errors.state?.message}</p>
          )}
        </label>
        <div className={style.submitButtonContainer}>
          <button
            className={style.submitButton}
            type="submit"
            disabled={!isValid || isLoading}
          >
            Submit
          </button>
        </div>
      </form>
      {isLoading && <Loader />}
      <Modal
        overlayClassName={style.reviewsModalOverlay}
        className={style.reviewsModal}
        isOpen={modalIsOpen}
        onRequestClose={resetStatus}
        contentLabel="Form submission status"
      >
        <div className={style.reviewsModalContainer}>
          {status === "success" ? (
            <div className={style.reviewsModalDoneContainer}>
              <Done />
              <h2 className={style.reviewsModalDoneText}>Done!</h2>
            </div>
          ) : (
            <div className={style.reviewsModalDoneContainer}>
              <Error />
              <h2 className={style.reviewsModalDoneText}>Error!</h2>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
